import api from 'services/api';

export async function login(values: { email: string; password: string }) {
  const response = await api.post('api/auth/login', {
    user: { ...values },
  });

  return response;
}
